import { assign } from 'xstate';
import { isBlockedUtility, SolarFunnelContext, solarMachine } from '~/machines/solar-funnel';
import { LDClient, LDFlags } from '~/providers';
import { fetchWaitlistOptions } from '~/services';
import { FunnelTrack } from '~/typings/graphql';
import { getInitialState } from '~/utils/funnels';
import { waitListFunnelRedirects } from '~/utils/redirects';
import { config } from './config';

export const funnelMachine = () => {
  return solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    user: {
      context: { requirePhone: true, showInviteCode: true },
    },
    utility: {
      context: { redirect: waitListFunnelRedirects },
    },
  }).withConfig({
    actions: {
      setUtilitySelection: assign((_context, event) => ({
        utilitySelection: event.data.utility,
        zipCode: event.data.zipCode,
        forceWaitlist: event.data.forceWaitlist,
      })),
      setWaitlistParams: assign((context, event) => {
        return {
          utilityScrapeEligible: event.data?.utilityScrapeEligible,
          funnelTrack: FunnelTrack.Waitlist,
          funnel: context.queryParams?.unparsedQueryParams?.funnel,
        };
      }),
    },
    guards: {
      isUtilityInWaitList: (context: SolarFunnelContext) => isFunnelTrackWaitlist(context),
      isWaitlistEnabled: () => LDClient.variation(LDFlags.waitlistEnabled),
      shouldWaitlistSkipPayment: context => {
        return isFunnelTrackWaitlist(context);
      },
      shouldUploadDocs: context => {
        const isWaitlist = isFunnelTrackWaitlist(context);
        // Skip upload doc screen if waitlist flow is enabled
        if (isWaitlist) {
          return false;
        }
        /**
         * technically, this should never return true because,
         * because this funnel only runs when isWalitList is true.
         * but im returning true anyways because otherwise linting will complain
         * not all code paths return a value
         */
        return true;
      },
    },
    services: {
      fetchWaitlistOptions: async context => {
        const { utilityScrapeEligible, funnelTrack } = await fetchWaitlistOptions({
          utilityId: context.funnelPacket!.utility.id,
        });
        return { utilityScrapeEligible, funnelTrack };
      },
    },
  });
};

export const isFunnelTrackWaitlist = (context: SolarFunnelContext) => {
  const shouldCheckForWaitlistFlow = LDClient.variation(LDFlags.waitlistEnabled);
  return (
    shouldCheckForWaitlistFlow &&
    (context.funnelTrack === FunnelTrack.Waitlist ||
      isBlockedUtility(context?.funnelPacket?.utility.id!))
  );
};
